export class Contact {
    enquiry: string;
    subject: string;
    policyNumber: string;
    message: string;
    tellUsWhy: string;
    tellUsText: string;
    username: string;
    userEmail: string;
}
